export default __webpack_public_path__ + "static/media/mrv-user-handbook-1.61b492d7.pdf";